"use strict";

var React = require('react'),
    Cmp = require('../../components'),
    ContactForm = require('../../partials/builder/BuilderContactForm');

var ToolboxSidebar = React.createClass({displayName: "ToolboxSidebar",
    contextTypes: {
        router: React.PropTypes.func
    },
    render: function() {
        return (
            React.createElement("div", {className: "col-sm-3 md-margin-bottom-40"}, 
                React.createElement("ul", {className: "list-group sidebar-nav-v1 margin-bottom-40"}, 
                    React.createElement(Cmp.NavLink, {to: "Dashboard", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-home"}), " Dashboard"
                    ), 
                    this.props.project.hasServiceType('AGENT_PORTAL') && (
                        React.createElement(Cmp.NavLink, {to: "Widgets", className: "list-group-item"}, 
                            React.createElement("i", {className: "fa fa-fw fa-th-large"}), " Get Widgets"
                        )
                    ), 
                    this.props.project.hasServiceType('PERSONALIZED_BROCHURES') && (
                        React.createElement(Cmp.NavLink, {to: "PersonalizedEmail", className: "list-group-item"}, 
                            React.createElement("i", {className: "fa fa-fw fa-envelope-o"}), " Agent Branded Emails"
                        )
                    ), 
                    this.props.project.hasServiceType('PERSONALIZED_BROCHURES') && (
                        React.createElement(Cmp.NavLink, {to: "PersonalizedBrochure", className: "list-group-item"}, 
                            React.createElement("i", {className: "fa fa-fw fa-file-pdf-o"}), " Agent Branded Brochures"
                        )
                    ), 
                    React.createElement(Cmp.NavLink, {to: "Documents", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-file-o"}), " Documents"
                    ), 
                    React.createElement(Cmp.NavLink, {to: "Images", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-picture-o"}), " Images"
                    ), 
                    React.createElement(Cmp.NavLink, {to: "FloorPlans", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-file-image-o"}), " Floor Plans"
                    ), 
                    React.createElement(Cmp.NavLink, {to: "Promotions", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-usd"}), " Promotions"
                    ), 
                    React.createElement(Cmp.NavLink, {to: "Contact", className: "list-group-item"}, 
                        React.createElement("i", {className: "fa fa-fw fa-envelope"}), " Contact Builder"
                    )
                ), 

                this.props.showContactForm && (
                    React.createElement(ContactForm, {model: this.props.project, saveOnOwnLine: true, smallHeader: true, hideValidationMessage: true})
                )
            )
        );
    }
});

module.exports = ToolboxSidebar;
